// What Scout offers to do next, under its latest reply. A click sends the offer as the next message.

export function FollowUpChips({ offers, onPick }: { offers: string[]; onPick: (offer: string) => void }) {
  if (offers.length === 0) return null;
  return (
    <div className="chatfollowups" role="group" aria-label="Ask Scout next">
      {offers.map(offer => (
        <button key={offer} type="button" className="chatfollowup" onClick={() => onPick(offer)}>{offer}</button>
      ))}
    </div>
  );
}
